import axios from "axios";
import { ToastError, ToastSuccess } from "../UiComponents/Toaster/Toast";
const URL = "https://coreapi.rayalbrokers.com/api";

const briskBulkUploadPolicy = async (recData) => {
    try {
        const response = await axios.post(`${URL}/briskBulkUploadPolicy`, recData);
        const res = response.data;
        if (res.error) {
            console.log(res.error);
            return null;
        } else {
            return res;
        }
    } catch (error) {
        console.log(error);
        ToastError(error?.response?.data?.message);
        return null;
    }
};

const briskMakeList = () => {
    return axios.get(`${URL}/briskMakeList`).then((response) => {
        const res = response.data;
        if (res.error) {
            console.log(res.error);
        } else {
            return res;
        }
    });
};

const briskModelList = (make) => {
    return axios
        .get(`${URL}/briskModelList/${make}`)
        .then((response) => {
            const res = response.data;
            if (res.error) {
                console.log(res.error);
            } else {
                return res;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};

const getCutPayDetailsByUserId = (data) => {
    return axios
        .get(`${URL}/getCutPayDetailsByUserId`)
        .then((response) => {
            const res = response.data;
            if (res.error) {
                console.log(res.error);
            } else {
                return res;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};

const getBriskWalletAmount = () => {
    return axios.get(`${URL}/getBriskWalletAmount`).then((response) => {
        const res = response.data;
        if (res.error) {
            console.log(res.error);
        } else {
            return res;
        }
    });
};

const createBriskCertificate = (recData) => {
    return axios
        .post(`${URL}/createBriskCertificate`, recData)
        .then((response) => {
            const res = response.data;
            if (res.error) {
                console.log(res.error);
            } else {
                return res;
            }
        });
};

const briskPlanList = () => {
    return axios
        .get(`${URL}/briskPlanList`)
        .then((response) => {
            const res = response.data;
            if (res.error) {
                console.log(res.error);
            } else {
                return res;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};

const saveBriskCertificate = (recData) => {
    return axios.post(`${URL}/saveBriskCertificate`, recData).then((response) => {
        const res = response.data;
        if (res.error) {
            console.log(res.error);
        } else {
            return res;
        }
    });
};

const formatCurrency = (amount) => {
    return (Number(amount) || 0).toLocaleString(
        "en-IN"
        //   {
        //   style: "currency",
        //   currency: "INR",
        // }
    );
};

const briskCertificateList = (
    selectedUser,
    selectedStartDate,
    selectedEndDate
) => {
    return axios
        .get(`${URL}/briskCertificateList`, {
            headers: {
                selectedUser: selectedUser,
                selectedStartDate: selectedStartDate,
                selectedEndDate: selectedEndDate,
            },
        })
        .then((response) => {
            const res = response.data;
            if (res.error) {
                console.log(res.error);
            } else {
                return res;
            }
        });
};

const cancelBriskCertificate = (recData) => {
    return axios
        .post(`${URL}/cancelBriskCertificate`, recData)
        .then((response) => {
            const res = response.data;
            if (res.error) {
                console.log(res.error);
            } else {
                return res;
            }
        });
};

const getBriskPolicyFileById = (_id) => {
    return axios
        .get(`${URL}/getBriskPolicyFileById/${_id}`)
        .then((response) => {
            const res = response.data;
            if (res.error) {
                console.log(res.error);
            } else {
                return res;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};

const ReframeEndDateTimeFormat = (endDate) => {
    let tempEndDate = new Date(endDate);
    let reframeDate = new Date(
        tempEndDate.setHours(23, 59, 59, 59)
        // tempEndDate.getMonth(),
        // tempEndDate.getDate(),
        // 23,
        // 59,
        // 59
    );
    return reframeDate;
};

const certificateList = (recData) => {
    return axios.get(`${URL}/certificateList`).then((response) => {
        const res = response.data;
        if (res.error) {
            console.log(res.error);
        } else {
            return res;
        }
    });
};

const getBriskWalletReportByUserId = (userId) => {
    return axios
        .get(`${URL}/getBriskWalletReportByUserId/${userId}`)
        .then((response) => {
            const res = response.data;
            if (res.error) {
                console.log(res.error);
            } else {
                return res;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};

const GetUserWalletByUserId = (type, data) => {
    return axios
        .get(`${URL}/getUserWalletByUserId/${type}`, {
            headers: {
                startdate: data.selectedStartDate,
                enddate: data.customEndDate,
            },
        })
        .then((response) => {
            const res = response.data;
            if (res.error) {
                console.log(res.error);
            } else {
                return res;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};

const addBriskWalletAmount = (recData) => {
    return axios.post(`${URL}/addBriskWalletAmount`, recData).then((response) => {
        const res = response.data;
        if (res.error) {
            console.log(res.error);
        } else {
            return res;
        }
    });
};

const getBriskWallet = (status) => {
    return axios.get(`${URL}/getBriskWallet/${status}`).then((response) => {
        const res = response.data;
        if (res.error) {
            console.log(res.error);
        } else {
            return res;
        }
    });
};

const getBriskWalletTransStatus = (orderId) => {
    return axios
        .get(`${URL}/briskWalletTransStatus/${orderId}`)
        .then((response) => {
            const res = response.data;
            if (res.error) {
                console.error(res.message);
            } else {
                return res;
            }
        });
};

const updateBriskPaymentScreenshot = (_id, recData) => {
    // console.log("id : ", _id);
    // console.log("ticketNumber : ", recData);
    return axios
        .put(`${URL}/updateBriskPaymentScreenshot/${_id}`, recData)
        .then((response) => {
            const res = response.data;
            if (res.error) {
                ToastError(res.message);
            } else {
                ToastSuccess(res.message);
                return res;
            }
        });
};

const updateBriskWalletByID = (_id, status) => {
    return axios
        .patch(`${URL}/updateBriskWalletByID/${_id}/${status}`)
        .then((response) => {
            const res = response.data;
            if (res.error) {
                ToastError(res.message);
            } else {
                // ToastSuccess(res.message);
                return res;
            }
        });
};

const getBriskWalletReport = (data) => {
    return axios
        .get(`${URL}/getBriskWalletReport/`, {
            headers: {
                userRef: data.userId,
                startdate: data.startDate,
                enddate: data.endDate,
            },
        })
        .then((response) => {
            const res = response.data;
            if (res.error) {
                console.log(res.error);
            } else {
                return res;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};

const GetUser = (data) => {
    return axios
        .get(`${URL}/user`, {
            headers: { requesttype: data.requesttype, isAscending: data.isAscending },
        })
        .then((response) => {
            const res = response.data;
            if (res.error) {
                console.log(res.error);
            } else {
                return res;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};

export {
    briskMakeList,
    briskModelList,
    briskBulkUploadPolicy,
    getCutPayDetailsByUserId,
    getBriskWalletAmount,
    createBriskCertificate,
    briskPlanList,
    saveBriskCertificate,
    formatCurrency,
    briskCertificateList,
    cancelBriskCertificate,
    getBriskPolicyFileById,
    ReframeEndDateTimeFormat,
    certificateList,
    getBriskWalletReportByUserId,
    GetUserWalletByUserId,
    addBriskWalletAmount,
    getBriskWallet,
    getBriskWalletTransStatus,
    updateBriskPaymentScreenshot,
    updateBriskWalletByID,
    getBriskWalletReport,
    GetUser,
};
